import { Form, Select } from "antd";
import { getIsVisibleLookups } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const JobLocationField = ({
  lookupTables = {},
  clientId,
  editData,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const jobLocations = lookupTables.jobLocation || [];

  const renderField = () => (
    <Select
      showSearch
      allowClear
      placeholder="Select Job Location"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      optionFilterProp="children"
      disabled={disabled}
      style={style}
    >
      {getIsVisibleLookups(
        jobLocations.filter(
          (lookup) => parseInt(lookup.clientId) === parseInt(clientId),
        ),
        editData?.jobLocation?.id,
      ).map((item) => (
        <Option key={item.id} value={item.id} disabled={item.isVisible !== 1}>
          {item.name}
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Job Location"
        className="formItemLocation"
        name="jobLocationsId"
        rules={[
          {
            required: true,
            message: "Please select job location",
          },
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Location" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
